var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-date_picker_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "date_picker_icon",
    clipPath: "url(#clip-date_picker_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8474",
    "data-name": "Group 8474",
    transform: "translate(-1131.049 -557.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_2_",
    "data-name": "calendar(2)",
    transform: "translate(1132.568 558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18546",
    "data-name": "Path 18546",
    d: "M15.3,1.373H13.725V.549a.549.549,0,0,0-1.1,0v.824H4.941V.549a.549.549,0,0,0-1.1,0v.824H2.265A2.267,2.267,0,0,0,0,3.637V15.3a2.267,2.267,0,0,0,2.265,2.265H15.3A2.267,2.267,0,0,0,17.568,15.3V3.637A2.267,2.267,0,0,0,15.3,1.373ZM2.265,2.471H3.843V3.02a.549.549,0,0,0,1.1,0V2.471h7.686V3.02a.549.549,0,0,0,1.1,0V2.471H15.3A1.168,1.168,0,0,1,16.47,3.637v1.3H1.1v-1.3A1.168,1.168,0,0,1,2.265,2.471Zm13.039,14H2.265A1.168,1.168,0,0,1,1.1,15.3V6.039H16.47V15.3A1.168,1.168,0,0,1,15.3,16.47Z",
    fill: "#20bead",
    stroke: "#20bead",
    strokeWidth: 0.28
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24188",
    "data-name": "Rectangle 24188",
    width: 8.5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(1137.049 568.049)",
    fill: "#20bead"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date_picker_icon.0e371075b74ca9964020e278448bab9d.svg";
export { ForwardRef as ReactComponent };